import { Button, Flex, Input, Select } from 'antd'
import React, { useMemo } from 'react'
import { Controller } from 'react-hook-form'
import { ButtonSearch } from 'src/assets/icons'
import { useTranslation } from 'react-i18next'
import { IOption, TableColumnDefs } from '../table.model'
import { useTableContext } from './TableProvider'
import { defaultActionColId, defaultMaxChar } from '../table.constants'
import { colorBorderSelected } from 'src/app/themes/primaryThemeDefault'

const TableSearch: React.FC = () => {
  const {
    searchOpen,
    defs,
    form,
    loading,
    displaySearch = true,
    disableTableControl = false,
    displayDateFilter,
    onSearch = () => {},
    setSearchOpen,
  } = useTableContext()
  const { t } = useTranslation()

  const searchColumnOptions: Array<IOption> = useMemo(() => {
    return (
      defs
        ?.filter((item) => {
          if (displayDateFilter) {
            return (
              !item?.hide &&
              !item?.isHideInSearchSelect &&
              ![defaultActionColId].includes(item?.colId) &&
              item.valueType !== 'date'
            )
          }
          return !item?.hide && !item?.isHideInSearchSelect && ![defaultActionColId].includes(item?.colId)
        })
        .map((item: TableColumnDefs) => ({
          label: item?.headerName,
          value: item?.colId,
        })) ?? []
    )
  }, [defs, displayDateFilter])

  const defaultOptions: Array<IOption> = useMemo(
    () => [
      {
        label: t('OverallFunctionality:table.search.default_option_title'),
        value: 'All',
      },
    ],
    [t],
  )

  if (!displaySearch || disableTableControl) {
    return <React.Fragment />
  }

  return (
    <React.Fragment>
      <Button
        icon={<ButtonSearch />}
        onClick={() => setSearchOpen?.(true)}
        style={{
          display: searchOpen ? 'none' : 'block',
          border: `1px solid ${colorBorderSelected}`,
        }}
      />
      <form
        onSubmit={form?.handleSubmit?.(onSearch)}
        style={{
          display: searchOpen ? 'block' : 'none',
        }}
      >
        <Flex id='search-section'>
          <Controller
            name='searchColumns'
            render={({ field }) => (
              <Select
                options={[...defaultOptions, ...searchColumnOptions]}
                style={{
                  width: 160,
                }}
                value={field.value}
                onChange={field.onChange}
                loading={loading}
                disabled={loading}
              />
            )}
            control={form?.control}
            disabled={loading}
          />
          <Controller
            name='searchTerm'
            render={({ field }) => (
              <Input
                allowClear
                value={field.value}
                onChange={field.onChange}
                style={{
                  width: 160,
                }}
                placeholder={t('OverallFunctionality:table.search.search_input_placeholder')}
                disabled={loading}
                maxLength={defaultMaxChar}
              />
            )}
            control={form?.control}
            disabled={loading}
            rules={{
              maxLength: {
                value: defaultMaxChar,
                message: t('OverallFunctionality:table.error.input_max_length_mesasge', { maxLength: defaultMaxChar }),
              },
            }}
          />
          <Button id='search-button' icon={<ButtonSearch />} htmlType='submit' />
        </Flex>
      </form>
    </React.Fragment>
  )
}

export default TableSearch
